var map = {
	"./Aatrox_0.png": 352,
	"./Ahri_0.png": 353,
	"./Akali_0.png": 354,
	"./Akshan_0.png": 355,
	"./Alistar_0.png": 356,
	"./Amumu_0.png": 357,
	"./Anivia_0.png": 358,
	"./Annie_0.png": 359,
	"./Aphelios_0.png": 360,
	"./Ashe_0.png": 361,
	"./AurelionSol_0.png": 362,
	"./Azir_0.png": 363,
	"./Bard_0.png": 364,
	"./Blitzcrank_0.png": 365,
	"./Brand_0.png": 366,
	"./Braum_0.png": 367,
	"./Caitlyn_0.png": 368,
	"./Camille_0.png": 369,
	"./Cassiopeia_0.png": 370,
	"./Chogath_0.png": 371,
	"./Corki_0.png": 372,
	"./Darius_0.png": 373,
	"./Diana_0.png": 374,
	"./DrMundo_0.png": 375,
	"./Draven_0.png": 376,
	"./Ekko_0.png": 377,
	"./Elise_0.png": 378,
	"./Evelynn_0.png": 379,
	"./Ezreal_0.png": 380,
	"./Fiddlesticks_0.png": 381,
	"./Fiora_0.png": 382,
	"./Fizz_0.png": 383,
	"./Galio_0.png": 384,
	"./Gangplank_0.png": 385,
	"./Garen_0.png": 386,
	"./Gnar_0.png": 387,
	"./Gragas_0.png": 388,
	"./Graves_0.png": 389,
	"./Gwen_0.png": 390,
	"./Hecarim_0.png": 391,
	"./Heimerdinger_0.png": 392,
	"./Illaoi_0.png": 393,
	"./Irelia_0.png": 394,
	"./Ivern_0.png": 395,
	"./Janna_0.png": 396,
	"./JarvanIV_0.png": 397,
	"./Jax_0.png": 398,
	"./Jayce_0.png": 399,
	"./Jhin_0.png": 400,
	"./Jinx_0.png": 401,
	"./Kaisa_0.png": 402,
	"./Kalista_0.png": 403,
	"./Karma_0.png": 404,
	"./Karthus_0.png": 405,
	"./Kassadin_0.png": 406,
	"./Katarina_0.png": 407,
	"./Kayle_0.png": 408,
	"./Kayn_0.png": 409,
	"./Kennen_0.png": 410,
	"./Khazix_0.png": 411,
	"./Kindred_0.png": 412,
	"./Kled_0.png": 413,
	"./KogMaw_0.png": 414,
	"./Leblanc_0.png": 415,
	"./LeeSin_0.png": 416,
	"./Leona_0.png": 417,
	"./Lillia_0.png": 418,
	"./Lissandra_0.png": 419,
	"./Lucian_0.png": 420,
	"./Lulu_0.png": 421,
	"./Lux_0.png": 422,
	"./Malphite_0.png": 423,
	"./Malzahar_0.png": 424,
	"./Maokai_0.png": 425,
	"./MasterYi_0.png": 426,
	"./MissFortune_0.png": 427,
	"./MonkeyKing_0.png": 428,
	"./Mordekaiser_0.png": 429,
	"./Morgana_0.png": 430,
	"./Nami_0.png": 431,
	"./Nasus_0.png": 432,
	"./Nautilus_0.png": 433,
	"./Neeko_0.png": 434,
	"./Nidalee_0.png": 435,
	"./Nocturne_0.png": 436,
	"./Nunu_0.png": 437,
	"./Olaf_0.png": 438,
	"./Orianna_0.png": 439,
	"./Ornn_0.png": 440,
	"./Pantheon_0.png": 441,
	"./Poppy_0.png": 442,
	"./Pyke_0.png": 443,
	"./Qiyana_0.png": 444,
	"./Quinn_0.png": 445,
	"./Rakan_0.png": 446,
	"./Rammus_0.png": 447,
	"./RekSai_0.png": 448,
	"./Rell_0.png": 450,
	"./Renata_0.png": 451,
	"./Renekton_0.png": 452,
	"./Rengar_0.png": 453,
	"./Riven_0.png": 454,
	"./Rumble_0.png": 455,
	"./Ryze_0.png": 456,
	"./Samira_0.png": 458,
	"./Sejuani_0.png": 459,
	"./Senna_0.png": 460,
	"./Seraphine_0.png": 462,
	"./Sett_0.png": 463,
	"./Shaco_0.png": 464,
	"./Shen_0.png": 465,
	"./Shyvana_0.png": 466,
	"./Singed_0.png": 467,
	"./Sion_0.png": 468,
	"./Sivir_0.png": 469,
	"./Skarner_0.png": 470,
	"./Sona_0.png": 471,
	"./Soraka_0.png": 472,
	"./Swain_0.png": 473,
	"./Sylas_0.png": 474,
	"./Syndra_0.png": 475,
	"./TahmKench_0.png": 476,
	"./Taliyah_0.png": 477,
	"./Talon_0.png": 478,
	"./Taric_0.png": 479,
	"./Teemo_0.png": 480,
	"./Thresh_0.png": 481,
	"./Tristana_0.png": 482,
	"./Trundle_0.png": 483,
	"./Tryndamere_0.png": 484,
	"./TwistedFate_0.png": 485,
	"./Twitch_0.png": 486,
	"./Udyr_0.png": 487,
	"./Urgot_0.png": 488,
	"./Varus_0.png": 489,
	"./Vayne_0.png": 490,
	"./Veigar_0.png": 491,
	"./Velkoz_0.png": 492,
	"./Vex_0.png": 493,
	"./Vi_0.png": 494,
	"./Viego_0.png": 495,
	"./Viktor_0.png": 496,
	"./Vladimir_0.png": 497,
	"./Volibear_0.png": 498,
	"./Warwick_0.png": 499,
	"./Xayah_0.png": 500,
	"./Xerath_0.png": 501,
	"./XinZhao_0.png": 502,
	"./Yasuo_0.png": 503,
	"./Yone_0.png": 505,
	"./Yorick_0.png": 506,
	"./Yuumi_0.png": 507,
	"./Zac_0.png": 508,
	"./Zed_0.png": 509,
	"./Zeri_0.png": 510,
	"./Ziggs_0.png": 511,
	"./Zilean_0.png": 512,
	"./Zoe_0.png": 513,
	"./Zyra_0.png": 514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;